import { DateRangeSchema } from 'common/hooks/customSearchParams';
import _ from 'lodash';
import moment from 'moment';
import * as React from 'react';
import { DateRangeSelector } from './DateRangeSelector';
import { Tab } from './Tab';

export interface RangeTab {
  label: string;
  node?: React.ReactNode;
  value: DateRangeSchema;
  order?: number;
}

const year = moment().year();

const options: RangeTab[] = [
  {
    label: 'Today',
    value: {
      exactDate: 'today',
    },
  },
  {
    label: 'Yesterday',
    value: {
      exactDate: '-1:days',
    },
  },
  {
    label: '7D',
    value: {
      startDate: '-7:days',
      endDate: 'today',
    },
  },
  {
    label: '30D',
    value: {
      startDate: '-30:days',
      endDate: 'today',
    },
  },
  {
    label: '3M',
    value: {
      startDate: '-3:months',
      endDate: 'today',
    },
  },
  {
    label: '6M',
    value: {
      startDate: '-6:months',
      endDate: 'today',
    },
  },
  {
    label: '12M',
    value: {
      startDate: '-12:months',
      endDate: 'today',
    },
  },
  {
    label: 'YTD',
    value: {
      startDate: `${year}-01-01`,
      endDate: 'today',
    },
  },
];

export interface Value {
  dateRange: DateRangeSchema;
  custom?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

interface Props {
  value: Value;
  onChange: (value: Value) => void;
  disabled?: boolean;
}

export const Tabs: React.FC<Props> = (props) => {
  const { value, onChange, disabled } = props;

  const tabs = React.useMemo(
    () =>
      options.map((option) => {
        const nonNullValues = _.pickBy(value.dateRange, _.identity);
        const isActive = _.isEqual(option.value, nonNullValues);
        return (
          <Tab
            key={option.label}
            label={option.label}
            active={isActive}
            onChange={() => onChange({ dateRange: option.value, custom: false })}
            value={option.value}
            disabled={disabled}
          />
        );
      }),
    [onChange, value, disabled]
  );

  return (
    <div className="flex">
      <DateRangeSelector value={value} onChange={onChange} />
      {tabs}
    </div>
  );
};
